import React from "react";

//icons
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";
import Icon from "../../../global/icons/Icon";



export interface ICommentButton {
    isDisabled?: boolean, 
    ariaLabel: string, 
    onButtonClick: any, 
    includeText: boolean, 
    isActive: boolean,
    isReply?: boolean,
    buttonText?: string
}

const CommentButton = ({isDisabled, ariaLabel, onButtonClick, includeText, isActive, isReply, buttonText}: ICommentButton) => {
    const text : string = isReply ? "Reply" : "Comment"

    return (
        <button
            className={`social-comment-button`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
        >
            <Icon iconName={isActive ? IconLibrary.COMMENT_ACTIVE : IconLibrary.COMMENT} sizeInPx="12"/>
            {includeText && (buttonText ?? text)}        
        </button>
    );
};

export default CommentButton